const getListOfCrops = (landParcels, allowOther = false) => {
    let listOfCrops = [];
    if (landParcels == null) return;
    landParcels.forEach(
        function callback(parcel) {
            let crops = parcel.crops.map(function (crop) {
                if (!crop.isOther) {
                    listOfCrops.push(crop.cropType)
                }
                else if (crop.isOther && allowOther) {
                    listOfCrops.push({
                        cropType: crop.cropType,
                        name: crop.name
                    });
                }
            });
        }
    );

    let uniqueCrops = [...new Set(listOfCrops)];
    if (allowOther) {
        uniqueCrops = uniqueCrops.filter((item, index, self) => {
            return !item.isOther || index === self.findIndex(t => t.isOther);
        });
    }

    return uniqueCrops.sort();
}

export default getListOfCrops;